import React from 'react';
import { useEmailOAuthCallback } from './useEmailOAuthCallback';
import EmailProcessingStatus from './components/EmailProcessingStatus';
import EmailSuccessStatus from './components/EmailSuccessStatus';
import EmailErrorStatus from './components/EmailErrorStatus';

export default function EmailOAuthCallbackPage() {
  const {
    status,
    errorMessage,
    provider,
    handleRetry,
    handleReturnToSettings
  } = useEmailOAuthCallback();

  const renderStatus = () => {
    switch (status) {
      case 'processing':
        return <EmailProcessingStatus provider={provider} />;
      case 'success':
        return <EmailSuccessStatus provider={provider} />;
      case 'error':
        return (
          <EmailErrorStatus
            message={errorMessage}
            provider={provider}
            onRetry={handleRetry}
            onReturnToSettings={handleReturnToSettings}
          />
        );
      default:
        return <EmailProcessingStatus provider={provider} />;
    }
  };

  return (
    <div style={{
      padding: '2rem',
      textAlign: 'center',
      maxWidth: '500px',
      margin: '0 auto',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }}>
      {renderStatus()}
    </div>
  );
}